export type ReferenceDataStore = {
  nationalities: ReferenceValue[];
  countries: ReferenceValue[];
  juridicForms: ReferenceValue[];
  metropolitanDepartments: ReferenceValue[];
  abroadDepartments: ReferenceValue[];
  subStatus: ReferenceValue[];
  identityPieceType: ReferenceValue[];
  habitation: ReferenceValue[];
  coholderType: ReferenceValue[];
  familySituation: ReferenceValue[];
  bankType: ReferenceValue[];
  professionCode: ReferenceValue[];
  contractCode: ReferenceValue[];
};

export type CatalogSearchResponse = {
  catalogResponseList: CatalogResponse[];
};

export type CatalogResponse = {
  catalogId: string;
  referenceValueDTOList: ReferenceValue[];
};

export type ReferenceValue = {
  key: string;
  value: string;
};

export enum ReferenceCategoryEnum {
  NATIONALITY = 'nationalite',
  COUNTRY = 'country',
  JURIDIC_FORM = 'juridique',
  METROPOLITAN_DEPARTMENT = 'franceDepartment',
  ABROAD_DEPARTMENT = 'domtomDepartment',
  SUB_STATUS = 'sous-status',
  IDENTITY_PIECE_TYPE = 'typePieceIdentite',
  HABITATION = 'habitation',
  CO_HOLDER_TYPE = 'coborrowers',
  FAMILY_SITUATION = 'sitFamiliale',
  BANK_TYPE = 'banque'
}

export const referenceDataStoreInitialValue = {
  nationalities: [],
  countries: [],
  juridicForms: [],
  metropolitanDepartments: [],
  abroadDepartments: [],
  subStatus: [],
  identityPieceType: [],
  habitation: [],
  coholderType: [],
  familySituation: [],
  bankType: [],
  professionCode: [],
  contractCode: []
};
